// 后台互动小说三个命名空间的西班牙文文案；key 结构与 en 完全一致（test/i18n.test.js 校验）。
export const novelEs = {
  novelPacks: {
    title: 'Obras de novela interactiva',
    filters: { status: 'Estado', allStatuses: 'Todos los estados', search: 'Palabra clave', searchPlaceholder: 'Título, slug o correo del creador', apply: 'Buscar' },
    status: { draft: 'Borrador', published: 'Publicada', unpublished: 'Retirada', archived: 'Archivada' },
    validation: { valid: 'Válida', invalid: 'Con errores' },
    listedInvalid: 'Las partidas nuevas fallarán',
    listedInvalidHint: 'Esta obra publicada ya no supera la revisión de contenido, así que los jugadores que empiecen una partida nueva recibirán un error.',
    table: { title: 'Obra', owner: 'Creador', latestVersion: 'Última versión', status: 'Estado', validation: 'Revisión de contenido', featured: 'Destacada', updatedAt: 'Actualizada' },
    notFeatured: 'No destacada',
    noVersion: 'Aún sin versión',
    emptyTitle: 'Ninguna obra de novela coincide con los filtros actuales.',
    actions: { preview: 'Vista previa', publish: 'Publicar', unpublish: 'Retirar', featured: 'Orden destacado' },
    publishConfirm: '¿Publicar «{title}»? Los jugadores la verán en la estantería y podrán empezar partidas nuevas de inmediato.',
    blocked: { invalid: 'No supera la revisión de contenido, no se puede publicar', archived: 'Archivada, no se puede publicar' },
    unpublishConfirm: '¿Retirar esta obra? Los jugadores nuevos dejarán de verla en la estantería; las partidas en curso pueden continuar.',
    toast: {
      published: 'Se publicó «{title}».',
      unpublished: 'Se retiró «{title}».',
      featuredSet: 'Se guardó el orden destacado de «{title}».',
      featuredCleared: '«{title}» ya no está destacada.',
    },
    featuredForm: {
      title: 'Orden destacado',
      rank: 'Orden destacado',
      hint: 'Un número entero, 0 o mayor. Los números más bajos aparecen primero en la estantería. Déjalo vacío para quitar la obra de destacadas.',
      clear: 'Quitar de destacadas',
      save: 'Guardar',
      invalid: 'Introduce un número entero, 0 o mayor.',
    },
    detail: {
      title: 'Detalles de la obra',
      owner: 'Creador',
      language: 'Idioma',
      status: 'Estado',
      currentVersion: 'Versión actual',
      validation: 'Revisión de contenido',
      listedAt: 'Última publicación',
      contentHash: 'Hash del contenido',
      createdAt: 'Creada',
      updatedAt: 'Actualizada',
      versions: 'Versiones',
      noVersions: 'Esta obra aún no tiene versiones.',
      assets: 'Recursos',
      noAssets: 'No hay recursos subidos.',
      openingCg: { title: 'CG inicial', loadVersion: 'Cargar versión publicada', assetKind: 'Tipo de recurso', video: 'Vídeo MP4', poster: 'Póster JPG', captions: 'Subtítulos VTT', file: 'Archivo', upload: 'Subir recurso' },
      close: 'Cerrar',
      cover: 'Portada',
      teaser: 'Resumen en la estantería',
      characters: 'Personajes',
      playerRole: 'Jugador',
      opening: 'Texto inicial',
      empty: 'Ninguno',
      openStudio: 'Abrir en Studio',
      openStudioHint: 'Studio solo abre una obra para su creador.',
      openPlayer: 'Ver en el sitio de jugadores',
      versionColumns: { version: 'Versión', note: 'Nota', validation: 'Revisión de contenido', publishedAt: 'Publicada', hash: 'Hash del paquete' },
      assetKinds: { cover: 'Portada', location: 'Lugar', state_image: 'Imagen de estado', item: 'Objeto' },
    },
    release: {
      title: 'Publicar en producción',
      hint: 'Envía a Main una versión que el creador generó en Stage. Main crea o actualiza la obra por su slug, convierte esa versión en su contenido actual y la publica; las imágenes se copian por clave de objeto. Nunca se copian partidas, jugadores ni registros contables.',
      refresh: 'Actualizar',
      stage: 'Stage',
      main: 'Main (producción)',
      selectedVersion: 'Versión seleccionada',
      versionNote: 'Nota de la versión',
      cutAt: 'Creada',
      connection: { connected: 'Conectado', not_configured: 'Sin configurar', unreachable: 'Error de conexión' },
      connectionHelp: { not_configured: 'Configura SCENARIO_RELEASE_TARGET_URL y SCENARIO_RELEASE_TOKEN en Stage (el mismo token en Main) y reinicia la API.', unreachable: 'Stage no pudo conectar con Main. Revisa la URL de destino, el token compartido y los registros de la API en ambos lados.' },
      mainVersion: 'Versión actual en Main',
      releasedAt: 'Última publicación',
      targetUrl: 'Destino',
      notOnMain: 'Aún no está en Main',
      noVersions: 'El creador todavía no ha generado ninguna versión. Las versiones se generan en Studio.',
      versionLabel: 'Versión a publicar',
      noNote: 'Sin nota',
      invalidVersion: 'Esta versión ya no supera la revisión de contenido, así que Main la rechazaría.',
      sameVersion: 'Main ya usa esta versión. Publicarla de nuevo vuelve a sincronizar su contenido e imágenes.',
      adminRequired: 'Solo los administradores pueden publicar. Los operadores pueden ver el estado y los registros.',
      publish: 'Publicar en producción',
      confirmTitle: '¿Publicar en producción?',
      confirmBody: 'Main convertirá la {version} de «{title}» en su contenido actual y la publicará de inmediato. Las imágenes que ya existen en Main con el mismo hash se reutilizan.',
      noUserData: 'No se copian partidas, jugadores ni registros contables.',
      progress: 'Publicando… no cierres esta ventana hasta que termine.',
      confirm: 'Publicar',
      successTitle: 'Publicada en producción',
      successSummary: '{version} ya está activa en Main · {copied} subidas, {reused} reutilizadas · {size} subidos',
      historyTitle: 'Registros de publicación',
      historyEmpty: 'Todavía no hay publicaciones.',
      operator: 'Operador',
      startedAt: 'Inicio',
      transfer: 'Imágenes (subidas / reutilizadas)',
      releaseId: 'ID de publicación',
      slugTaken: 'Main ya tiene una obra con el slug «{slug}» creada por un creador de Main. El canal de publicación no puede sobrescribirla, así que la publicación está desactivada.',
      reasonCodes: {
        FORBIDDEN: 'Main rechazó el token compartido de publicación. SCENARIO_RELEASE_TOKEN debe ser igual en Stage y en Main.',
        NOT_FOUND: 'Main no tiene la interfaz o el registro de publicación de novelas. Comprueba que Main ejecuta la misma versión del código.',
      },
      logs: {
        locked: 'Versión {version} de Stage fijada con {assets} objetos',
        received: 'Versión {version} de Stage recibida con {assets} objetos',
        sending: 'Enviando el paquete de publicación a producción',
        syncing: 'Verificando y sincronizando imágenes',
        writing: 'Imágenes sincronizadas ({copied} subidas, {reused} reutilizadas); escribiendo la obra y la versión',
        switched: 'Producción cambió a {version}',
        failed: 'Error: {reason}',
      },
      stale: {
        hint: 'Esta publicación lleva más de 30 minutos sin avanzar; probablemente la API se reinició durante la publicación. Bloquea nuevas publicaciones de esta obra hasta que la cierres como fallida.',
        hintOperator: 'Esta publicación lleva más de 30 minutos sin avanzar y bloquea nuevas publicaciones de esta obra. Pide a un administrador que la cierre.',
        finish: 'Cerrar como fallida',
      },
      status: { prepared: 'Preparada', transferring: 'Transfiriendo', applying: 'Aplicando', succeeded: 'Completada', failed: 'Fallida' },
    },
    pager: { prev: 'Anterior', next: 'Siguiente', pageSize: 'Por página', summary: '{total} obras · página {page} de {pages}' },
  },
  novelRuns: {
    title: 'Partidas de novela',
    list: {
      filters: { email: 'Correo del jugador', emailPlaceholder: 'Buscar por correo', pack: 'Obra', packSearch: 'Todas las obras (escribe para buscar título, slug o correo del creador)', packSearching: 'Buscando…', packEmpty: 'No hay obras que coincidan', packClear: 'Quitar filtro de obra', failedOnly: 'Solo partidas con tareas fallidas', apply: 'Buscar' },
      table: { player: 'Jugador', pack: 'Obra', status: 'Estado', turns: 'Turnos', jobs: 'Tareas en segundo plano', failedJobs: 'Tareas fallidas', lastPlayed: 'Última partida', actions: 'Acciones' },
      statuses: { active: 'Activa', archived: 'Archivada' },
      jobsPending: 'Pendientes',
      jobsIdle: 'Ninguna',
      unknownUser: 'Jugador desconocido',
      empty: 'Ninguna partida coincide con estos filtros',
      audit: 'Auditar',
      filterByPack: 'Mostrar solo las partidas de esta obra',
      pager: { prev: 'Anterior', next: 'Siguiente', pageSize: 'Por página', summary: '{total} partidas · página {page} de {pages}' },
    },
    audit: {
      back: 'Partidas',
      refresh: 'Actualizar',
      empty: 'Ninguno',
      copy: 'Copiar',
      copied: 'Copiado',
      copyFailed: 'No se pudo copiar: {message}',
      copyId: 'Copiar {id}',
      points: '{points} pts',
      separator: ', ',
      spoilerNotice: 'Contiene spoilers, vista de autor: ajustes ocultos, conocimiento de los personajes, prompts reales y salida del modelo. No lo compartas con jugadores.',
      tabs: { overview: 'Resumen', characters: 'Personajes', timeline: 'Cronología', director: 'Director', story: 'Historia', calls: 'Llamadas', drama: 'Avatar digital', raw: 'Datos sin procesar' },
      bar: {
        turns: 'Turno {count}',
        jobsPending: 'Tareas pendientes',
        jobsIdle: 'Sin tareas',
        writer: 'Escritor {model}',
        writerTitle: 'Escritor de esta partida: {performer}; último modelo real: {model}',
        points: '{points} pts en total',
        refreshTitle: 'Última actualización: {time}. Solo lectura; abrir esta página no llama a ningún modelo.',
        retryFailed: 'Reintentar tareas fallidas ({count})',
      },
      overview: { runInfo: 'Datos de la partida', player: 'Jugador', work: 'Obra', packageHash: 'Hash del contenido', created: 'Creada', lastPlayed: 'Última partida', branch: 'Rama' },
      branch: { active: 'activa', candidate: 'candidata', option: '{id} · {state} · {turns} turnos' },
      scene: {
        title: 'Escena actual',
        people: 'Presentes',
        storyTime: 'Tiempo de la historia',
        items: 'Objetos aquí',
        recording: {
          pending: 'El texto está guardado; la escena y el conocimiento de los personajes se actualizan en segundo plano.',
          failed: 'El texto está guardado, pero falló el registro en segundo plano; reinténtalo desde la lista de tareas en Llamadas.',
        },
      },
      request: {
        title: 'Última solicitud',
        input: 'Entrada',
        status: 'Estado',
        elapsed: 'Duración',
        cost: 'Coste',
        stage: 'Etapa',
        model: 'Modelo',
        unrecorded: 'No se guardaron registros de etapas del modelo para esta solicitud; no se reconstruye nada a partir de plantillas.',
      },
      roles: { performer: 'Escritor', structured: 'Estructurado' },
      time: {
        day: 'Día {day}',
        phases: { morning: 'Mañana', afternoon: 'Tarde', evening: 'Anochecer', night: 'Noche' },
      },
      requestStatuses: { generating: 'Generando', committed: 'Confirmada', failed: 'Fallida', cancelled: 'Cancelada' },
      stageStatuses: { started: 'Iniciada', completed: 'Completada', failed: 'Fallida' },
      turns: {
        turn: 'Turno {seq}',
        modes: { mixed: 'Diálogo y acción', speech: 'Diálogo', action: 'Acción', continue: 'Continuar' },
        recordingStates: { pending: 'Registro pendiente', completed: 'Registrado', failed: 'Registro fallido' },
      },
      characters: {
        list: 'Personajes',
        openCount: '{count} abiertos',
        appearance: 'Apariencia',
        identity: 'Identidad',
        initialGoal: 'Objetivo inicial',
        latestGoal: 'Objetivo más reciente',
        sections: { opening: 'Ajustes iniciales', later: 'Registros posteriores', witness: 'Testimonios y observaciones', memory: 'Memoria continua' },
        facts: 'Hechos conocidos',
        relations: 'Relaciones',
        portrayal: 'Personalidad y voz',
        personality: 'Personalidad',
        speechStyle: 'Voz',
        cues: 'Pautas de interpretación',
        examples: 'Ejemplos de voz (no son historial)',
        attitude: 'Actitud',
        goals: 'Objetivos',
        threads: 'Asuntos abiertos',
        thread: 'Asunto',
        witnessed: 'Pasajes presenciados',
        witnessTurn: 'Turno',
        witnessText: 'Pasaje',
        witnessBy: 'Presenciado por',
        witnessPending: 'Testimonios pendientes del registro narrativo: turnos {turns}',
        witnessFailed: 'Falló el registro narrativo de {range}: {reason}',
        observations: 'Observaciones',
        memoryProgress: 'hasta el turno {count}',
      },
      timeline: {
        positions: 'Posiciones',
        placePeople: ': {people}',
        events: 'Eventos',
        audience: 'Presenciado por',
        moves: 'Movimientos',
        timeChange: 'Tiempo de la historia',
        transfers: 'Traspasos de objetos',
        kinds: { move: 'Movimiento', time: 'Tiempo de la historia', transfer: 'Traspaso de objeto', witness: 'Presenciado' },
        items: 'Objetos',
        item: 'Objeto',
        holder: 'Poseedor',
        place: 'Lugar',
        unheld: 'Sin poseedor',
      },
      director: {
        on: 'Director activado',
        off: 'Director desactivado',
        unknown: 'Director sin registrar',
        revision: 'Revisión {revision}',
        latest: 'Última sugerencia',
        directionStatus: 'Estado',
        basis: 'Basada en',
        validThrough: 'Válida hasta',
        guidanceId: 'Sugerencia',
        deliveries: 'Entrega por turno',
        deliveriesHint: '«Pasada al escritor» se juzga solo por el registro de inyección guardado; el texto no puede demostrar que el modelo la adoptó.',
        turn: 'Turno',
        delivery: 'Entrega',
        passedWriter: 'Pasada al escritor',
        reason: 'Motivo',
        yes: 'Sí',
        no: 'No',
        notRecorded: 'Sin registrar',
        hashPending: 'Comprobando',
        hashFailed: 'No se puede calcular',
        hashFailedHint: 'Este navegador no puede calcular el hash de preferencias (necesita HTTPS o localhost), así que no se sabe si la sugerencia es utilizable.',
        statuses: {
          disabled: 'Desactivado',
          pending: 'Preparando',
          ready: 'Lista',
          unavailable: 'Sin sugerencia',
          available: 'Disponible',
          expired: 'Caducada',
          not_ready: 'No lista',
          injected_direction: 'Inyectada',
        },
        statusHints: {
          disabled: 'Desactivado: sin llamada ni inyección.',
          pending: 'Preparando la sugerencia en segundo plano; el texto no espera.',
          ready: 'La dirección está disponible.',
          unavailable: 'No hay ninguna sugerencia disponible.',
          available: 'Disponible para esta etapa.',
          expired: 'Solo se muestra como referencia; ya no se inyecta.',
          not_ready: 'No inyectada: la sugerencia no estaba lista.',
          injected_direction: 'Dirección de etapa inyectada.',
        },
        reasons: {
          director_disabled: 'Desactivado: sin llamada ni inyección.',
          guidance_pending: 'Preparando la sugerencia en segundo plano; el texto no espera.',
          guidance_unavailable: 'No hay ninguna sugerencia disponible.',
          guidance_expired: 'Solo se muestra como referencia; ya no se inyecta.',
          recording_pending: 'El registro del texto todavía se está preparando en segundo plano.',
          director_revision_changed: 'Cambió la revisión de la configuración del Director.',
          preferences_changed: 'Cambiaron las preferencias fuera de la historia.',
          phase_direction: 'Se incluyó la dirección de etapa.',
        },
      },
      preferences: {
        title: 'Preferencias fuera de la historia',
        kinds: { pace: 'Ritmo', focus: 'Personaje en foco', direction: 'Dirección', expectation: 'Expectativa fuera de la historia' },
        scopes: { branch: 'Esta partida', next_4_turns: 'Próximos cuatro turnos' },
        sources: { explicit_ui: 'fijada por el jugador', explicit_ooc_expectation: 'escrita por el jugador' },
        paces: { linger: 'Detenerse', follow: 'Seguir al jugador', advance: 'Avanzar' },
      },
      story: {
        title: 'Registro de la historia',
        turnCount: '{count} turnos',
        opening: 'Inicio',
        narrator: 'Narrador',
        playerInput: 'Entrada del jugador',
        channels: { narration: 'Narración', dialogue: 'Diálogo', action: 'Acción' },
        metadataPending: 'Pendiente de registro',
        audience: 'Presenciado por: {names}',
        generating: 'Se está generando un turno; su borrador en vivo solo existe en el proceso de juego y no es visible aquí.',
      },
      sources: {
        evidence: 'Evidencia {count}',
        evidenceLabel: 'Fuentes de evidencia',
        missing: 'El texto de la fuente no está guardado',
        range: 'Turnos {from}–{through}',
        turn: 'Turno {count}',
        kinds: { opening: 'Inicio', author_fact: 'Hecho inicial del autor', event: 'Evento registrado', turn: 'Turno de la historia', unknown: 'Evidencia guardada' },
      },
      memoryKinds: {
        observed: 'Observado',
        reported: 'Contado',
        belief: 'Creencia',
        interpretation: 'Interpretación',
        correction: 'Corrección de memoria',
        conflict: 'Conflicto de memoria',
        record: 'Registro de memoria',
      },
      calls: {
        title: 'Llamadas al modelo',
        count: '{count} llamadas',
        totalCost: 'Coste total {cost}',
        failedCount: '{count} fallidas',
        time: 'Hora',
        source: 'Origen',
        role: 'Rol',
        model: 'Modelo · proveedor',
        status: 'Estado',
        ttft: 'Primer token',
        duration: 'Duración',
        tokens: 'Tokens entrada / salida',
        cost: 'Coste',
        expand: 'Mostrar el cuerpo de la solicitud y la salida',
        sourceRequest: 'Solicitud',
        sourceJob: 'Tarea en segundo plano',
        sourceOther: 'Otro',
        statuses: { ok: 'Correcta', error: 'Error', aborted: 'Interrumpida' },
        callId: 'Llamada',
        authNotRecorded: 'las cabeceras de autenticación y las variables de entorno nunca se registran',
        requestBody: 'Cuerpo de la solicitud',
        messageCount: '{count} mensajes',
        chars: '{count} caracteres',
        output: 'Salida',
        reasoning: 'Razonamiento',
        finishReason: 'Motivo de finalización',
        protocol: 'Protocolo',
        unavailable: 'No disponible en la auditoría de la plataforma',
      },
      drama: {
        title: 'Actuaciones del avatar',
        hint: 'Una actuación por turno; los puntos se reservan al empezar y se devuelven si falla antes del primer fotograma.',
        time: 'Inicio',
        person: 'Personaje y estado',
        duration: 'Duración',
        firstFrame: 'Primer fotograma',
        result: 'Resultado',
        points: 'Puntos',
        refund: 'Reembolso',
        refunded: 'Reembolsado',
        refundedTotal: '{points} pts reembolsados',
        count: '{count} actuaciones',
        empty: 'Esta partida no tiene actuaciones del avatar.',
        statuses: { starting: 'Conectando', live: 'Actuando', ended: 'Terminada' },
        reasons: { completed: 'Completada', cancelled_during_start: 'Cancelada al empezar', disconnected: 'Desconectada', start_failed: 'Error al empezar', playback_failed: 'Error de reproducción', hidden: 'Página oculta', switched_off: 'Desactivada', unmounted: 'Salió de la página', turn_cancelled: 'Turno cancelado', replaced: 'Reemplazada por otra actuación', browser_disconnected: 'Conexión de control perdida', expired: 'Límite de tiempo alcanzado', interrupted: 'Interrumpida por un reinicio del servidor' },
      },
      jobs: {
        title: 'Tareas en segundo plano',
        kind: 'Tipo',
        range: 'Turnos',
        status: 'Estado',
        attempts: 'Intentos',
        nextRetry: 'Próximo reintento',
        error: 'Error',
        retry: 'Reintentar',
        retried: '{count} tarea(s) en cola para reintentar',
        trigger: 'Disparador: {trigger}',
        completed: 'Completada: {time}',
        kinds: { narrative_record: 'Registrar turno', memory: 'Memoria', director: 'Director', suggestions: 'Sugerencias' },
        triggers: { cadence: 'Rutina cada cuatro turnos', enabled: 'Director activado', preference_changed: 'Preferencias cambiadas', forked: 'Rama bifurcada' },
        statuses: { pending: 'Pendiente', completed: 'Completada', failed: 'Fallida', superseded: 'Sustituida' },
      },
      requests: { title: 'Solicitudes de turno', time: 'Inicio', turn: 'Turno', input: 'Entrada', status: 'Estado', error: 'Error', elapsed: 'Duración', points: 'Puntos', id: 'ID', diagnostics: 'Comentarios de validación', diagnosticsCount: '{count} elementos', diagnosticsExpand: 'Mostrar {count} comentarios de validación' },
      diagnostics: {
        raw: 'Salida del modelo · {count} caracteres',
        kinds: {
          narrative_format: 'Revisión de formato',
          narrative_preamble: 'Texto antes de la historia',
          narrative_tag_normalization: 'Normalización de etiquetas',
          narrative_recording: 'Registro de la historia',
          narrative_continuity: 'Revisión de continuidad',
          memory_owner_failure: 'Fallo de memoria del personaje',
        },
      },
      errors: {
        unknown: 'Error sin clasificar',
        internal_error: 'Error interno del servidor',
        interrupted: 'Interrumpido por un reinicio del servicio',
        cancelled: 'Cancelado',
        insufficient_balance: 'Saldo de puntos insuficiente',
        stale_turn: 'La partida guardada cambió antes de que terminara este turno',
        busy: 'Había otra solicitud en curso',
        run_archived: 'La partida está archivada',
        invalid_data: 'Datos no válidos',
        content_filter: 'Bloqueado por el filtro de contenido',
        model_output_limit: 'La salida del modelo alcanzó el límite de longitud',
        model_response_blocked: 'El modelo se negó o la política de seguridad bloqueó la respuesta',
        incomplete_model_output: 'La salida del modelo quedó incompleta',
        model_not_configured: 'No hay ningún modelo configurado para esta etapa',
        context_limit: 'El contexto supera el límite del modelo',
        invalid_structured_json: 'No se pudo analizar la salida estructurada',
        invalid_narrative_format: 'El formato del texto narrativo no es válido',
        invalid_performance: 'La configuración de personaje o escenario no es válida',
        invalid_performance_states: 'La salida de estado del escritor no es válida',
        missing_narrative_tags: 'Al texto le faltan las etiquetas de hablante',
        invalid_speaker: 'Hablante no válido',
        invalid_narrative_record: 'La salida del registro narrativo no es válida',
        narrative_recording_failed: 'Falló el registro narrativo',
        narrative_record_gap: 'Los turnos anteriores aún no están registrados',
        invalid_story_time: 'Tiempo de la historia no válido',
        invalid_item_transfer: 'Traspaso de objeto no válido',
        invalid_scene_location: 'Lugar de la escena no válido',
        invalid_scene_path: 'Ruta de movimiento no válida',
        source_conflict: 'Las fuentes de evidencia se contradicen',
        memory_too_long: 'El resumen de memoria es demasiado largo',
        memory_source_too_large: 'Demasiado material de origen para una tarea de memoria',
        memory_context_limit: 'El contexto de memoria supera el límite del modelo',
        memory_backlog_waiting: 'Esperando tareas de memoria anteriores',
        invalid_correction: 'Corrección de memoria no válida',
        unsupported_correction: 'Corrección de memoria no admitida',
        invalid_player_suggestions: 'La salida de sugerencias de respuesta no es válida',
        invalid_preference: 'Preferencia no válida',
        job_conflict: 'Tarea en conflicto',
        package_integrity_failed: 'El contenido de la obra no superó la comprobación de integridad',
      },
      raw: {
        title: 'Datos sin procesar',
        pack: 'Contenido de la obra',
        snapshot: 'Instantánea completa',
        requests: 'Registros de solicitudes',
        contextNote: 'context_records son instantáneas del contexto en ejecución; solo los cuerpos de solicitud de la pestaña Llamadas son lo que se envió al modelo.',
      },
    },
  },
  novelErrors: {
    unknown: 'Error sin clasificar',
    codes: {
      BAD_REQUEST: 'El servidor rechazó la solicitud por no ser válida.',
      VALIDATION_ERROR: 'El servidor rechazó la solicitud por no ser válida.',
      UNAUTHORIZED: 'Tu sesión ha caducado. Vuelve a iniciar sesión.',
      FORBIDDEN: 'Esta cuenta no tiene permiso para hacer eso.',
      NOT_FOUND: 'Ya no existe.',
      CONFLICT: 'Los datos cambiaron mientras tanto. Actualiza e inténtalo de nuevo.',
      NOVEL_RELEASE_NOT_CONFIGURED: 'Stage no tiene configurado el destino de publicación en producción.',
      NOVEL_RELEASE_TARGET_UNREACHABLE: 'Stage no pudo conectar con producción. Consulta el registro de publicación de abajo.',
      NOVEL_RELEASE_TARGET_REJECTED: 'Producción rechazó la publicación. Consulta el motivo en el registro de abajo.',
      NOVEL_RELEASE_FAILED: 'Producción no pudo aplicar la publicación. La causa está en el detalle del registro.',
      NOVEL_RELEASE_STORAGE_RESIDUE: 'El contenido aún hace referencia a direcciones de almacenamiento que no se pueden reescribir (dominio OSS antiguo, http o parámetros de consulta). Corrige las direcciones de las imágenes en Studio, crea una nueva versión y vuelve a publicar.',
      NOVEL_RELEASE_STALE: 'La publicación se quedó detenida (la API se reinició durante la publicación) y un administrador la cerró como fallida.',
      NOVEL_RELEASE_IN_PROGRESS: 'Producción sigue aplicando esta publicación. El registro sigue en curso y se actualizará cuando se confirme el recibo; actualiza más tarde.',
      NOVEL_RELEASE_ALREADY_FAILED: 'Este ID de publicación ya falló. Inicia una nueva publicación.',
      NOVEL_RELEASE_CHECKSUM_MISMATCH: 'Producción detectó que el checksum del paquete de publicación no coincide.',
      NOVEL_RELEASE_BUNDLE_INVALID: 'Producción detectó que la lista de objetos del paquete no coincide con el contenido.',
      RATE_LIMITED: 'Demasiadas solicitudes. Inténtalo de nuevo en un momento.',
      INTERNAL_ERROR: 'Error del servidor. Inténtalo de nuevo más tarde.',
      HTTP_ERROR: 'La solicitud falló.',
    },
    reasons: {
      release_in_progress: 'Esta obra ya tiene una publicación en curso. Espera a que termine.',
      release_id_conflict: 'Este ID de publicación ya corresponde a otro contenido.',
      release_slug_taken: 'Main ya tiene una obra con este slug creada por un creador de Main, así que la publicación no puede sobrescribirla.',
      release_version_conflict: 'Main ya tiene este número de versión con contenido distinto. Crea una versión nueva en Studio y publícala.',
      release_content_invalid: 'Esta versión no pasa la comprobación de contenido de Main, así que Main no la aplicó.',
      release_pack_archived: 'La obra en Main está archivada, así que no se puede publicar en ella.',
      release_not_stale: 'Esta publicación sigue avanzando. Solo se pueden cerrar publicaciones detenidas más de 30 minutos.',
      release_invalid_transition: 'Este registro de publicación ya terminó. Actualiza para ver su estado.',
      release_not_found: 'Este registro de publicación ya no existe.',
      pack_not_found: 'Esta obra ya no existe.',
      pack_content_invalid: 'El contenido no supera la revisión, así que la obra no se puede publicar.',
      invalid_status_transition: 'El estado actual de esta obra no permite esta acción. Actualiza e inténtalo de nuevo.',
      invalid_featured_rank: 'El orden destacado debe ser un número entero, 0 o mayor.',
      run_not_found: 'Esta partida ya no existe.',
      run_archived: 'Esta partida está archivada, así que sus tareas no se pueden reintentar.',
      adopt_forbidden: 'Solo el dueño de la partida de origen puede adoptar un lado.',
      stale_comparison: 'La partida de origen avanzó desde que empezó la comparación. Reinicia la comparación.',
      already_adopted: 'Ya se adoptó un lado de esta comparación.',
      nothing_to_adopt: 'Este lado aún no tiene turnos nuevos para adoptar.',
      comparison_not_found: 'Esta comparación ya no existe (se eliminan tras 24 horas).',
      invalid_comparison_source: 'Una partida de comparación no puede ser el origen de otra comparación.',
      model_not_configured: 'El modelo de escritura elegido no está configurado.',
      invalid_performer: 'El modelo elegido no está en la cadena de escritura.',
      invalid_director_comparison: 'Para comparar solo el director, ambos lados deben usar el mismo modelo.',
      narrative_required: 'Esta obra no tiene texto, así que no se puede comparar.',
      busy: 'La partida está generando. Inténtalo cuando termine.',
    },
  },
}
